import React from 'react';
import { motion } from 'framer-motion';
import { FiHeart, FiCode } from 'react-icons/fi';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <motion.div 
            className="footer-brand"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h3 className="brand-name">Paule Development</h3>
            <p className="brand-tagline">Building the future, one line of code at a time.</p>
          </motion.div>
          
          <motion.div 
            className="footer-links"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h4>Quick Links</h4>
            <div className="links-list">
              <button onClick={() => document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' })}>
                Home
              </button>
              <button onClick={() => document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' })}>
                Projects
              </button>
              <button onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
                Contact
              </button>
            </div>
          </motion.div>
          
          <motion.div 
            className="footer-projects"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <h4>Featured Work</h4>
            <div className="project-links">
              <a href="https://loldodgegame.com" target="_blank" rel="noopener noreferrer">
                LoL Dodge Game
              </a>
              <a href="https://onestreamrpg.com" target="_blank" rel="noopener noreferrer">
                One Stream RPG
              </a>
              <a href="https://purepng.com" target="_blank" rel="noopener noreferrer">
                PurePNG
              </a>
            </div>
          </motion.div>
        </div>
        
        <motion.div 
          className="footer-bottom"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          viewport={{ once: true }}
        >
          <div className="copyright">
            <p>
              © {currentYear} Paule Development. Made with{' '}
              <motion.span
                className="heart"
                animate={{ scale: [1, 1.2, 1] }}
                transition={{ duration: 1, repeat: Infinity, ease: "easeInOut" }}
              >
                <FiHeart />
              </motion.span>
              {' '}and{' '}
              <motion.span
                className="code"
                animate={{ rotate: [0, 360] }}
                transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
              >
                <FiCode />
              </motion.span>
            </p>
          </div>
          
          <motion.button 
            className="scroll-to-top"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            whileHover={{ scale: 1.1, y: -2 }}
            whileTap={{ scale: 0.9 }}
          >
            ↑
          </motion.button>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
